<template>
  <v-layout row justify-center>
    <v-container>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step
            :complete="step > 1"
            :editable="setSteps == 1"
            step="1"
            v-if="setSteps >= 1"
            >Ano Letivo
            <span v-if="choices.aaletivo">
              {{ choices.aaletivo }}
            </span>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="step > 2"
            :editable="setSteps == 2 && step > setSteps"
            step="2"
            v-if="setSteps >= 2"
            >Turma
            <span v-if="choices.cdturma">
              {{ nomeTurma }}
            </span>
          </v-stepper-step>

          <v-divider v-if="setSteps >= 3"></v-divider>

          <v-stepper-step
            :complete="step > 3"
            :editable="step > 3"
            step="3"
            v-if="setSteps >= 3"
          >
            {{ labelDisciplina }}
            <span v-if="choices.cddiscipl">
              {{ nomeDisciplina }}
            </span>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-radio-group v-if="anoletivo.length" v-model="choices.aaletivo">
              <v-radio
                color="#25848C"
                :ripple="false"
                v-for="aaletivo in anoletivo"
                :key="key(aaletivo.value)"
                :label="aaletivo.text.toString()"
                :value="aaletivo.value"
              />
            </v-radio-group>
            <p v-if="!anoletivo.length">Nenhuma ano letivo encontrado</p>

            <v-btn
              v-if="setSteps !== 1"
              class="rounded-sm font-weight-regular"
              :disabled="!choices.aaletivo || loading"
              color="primary"
              @click="getTurma()"
              :loading="loading"
              >Continuar</v-btn
            >
            <v-btn
              v-if="setSteps === 1"
              color="success"
              :disabled="!choices.aaletivo"
              @click="confirm"
              >Confirmar</v-btn
            >
          </v-stepper-content>
          <!-- segundo -->
          <v-stepper-content step="2">
            <v-radio-group v-if="turmas.length" v-model="choices.cdturma">
              <v-radio
                color="#25848C"
                :ripple="false"
                v-for="turma in turmas"
                :key="key(turma.value)"
                :label="turma.text.toString()"
                :value="turma.value"
                @change="changeTurmaSelected(turma)"
              />
            </v-radio-group>

            <p v-else>Nenhuma turma encontrada</p>

            <v-btn
              class="rounded-sm font-weight-regular me-2"
              v-if="setSteps !== 2"
              :disabled="!choices.cdturma || loading"
              color="primary"
              @click="getEtapa()"
              :loading="loading"
              >Continuar</v-btn
            >
            <v-btn
              class="rounded-sm font-weight-regular"
              v-if="setSteps === 2"
              color="success"
              :disabled="!choices.cdturma"
              @click="confirm"
              >Confirmar</v-btn
            >
            <v-btn class="rounded-sm font-weight-regular" @click="back('cdturma')">Voltar</v-btn>
          </v-stepper-content>
          <!-- terceiro -->
          <v-stepper-content step="3">
            <v-radio-group
              v-if="disciplinas.length"
              v-model="choices.cddiscipl"
            >
              <v-radio
                color="#25848C"
                :ripple="false"
                v-for="disciplina in disciplinas"
                :key="key(disciplina.value)"
                :label="disciplina.text.toString()"
                :value="disciplina.value"
              >
              </v-radio>
            </v-radio-group>

            <p v-else>Nenhuma disciplina encontrada</p>
            <v-btn
              class="rounded-sm font-weight-regular me-2"
              v-if="setSteps === 3"
              color="success"
              :disabled="!choices.cddiscipl"
              @click="confirm"
              >Confirmar</v-btn
            >
            <v-btn class="rounded-sm font-weight-regular" @click="back('cddiscipl')">Voltar</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </v-layout>
</template>

<script>
//import api from "@/api";
import _ from "lodash";
import { mapGetters } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import {ehTurmaAEEouACP} from "@/utils/turmas"

const TurmasRepository = RepositoryFactory.get("turma");
const DisciplinaRepository = RepositoryFactory.get("disciplina");

const defaultstate = () => ({
  options: {
    aaletivo: [],
    cdturma: [],
    cddiscipl: [],
  },
  choices: {
    aaletivo: null,
    cdturma: null,
    cddiscipl: null,
    tipoDeEnsino: "",
    cdinstruc: null,
  },
  step: 1,
  loading: false,
});

const defaultSelect = () => ({
  text: "",
  value: "",
});

export default {
  name: "busca-ano-turma-disciplina-aee-acp",
  props: {
    setSteps: {
      type: Number,
      default: 3,
    },
  },
  async created() {
    this.getAno();
  },
  data() {
    return defaultstate();
  },
  methods: {
    changeTurmaSelected(turmaSelected) {
      this.choices.tipoDeEnsino = turmaSelected.tipodeensino;
      this.choices.cdinstruc = turmaSelected.cdinstruc;
    },
    async getAno() {
      this.loading = true;
      if (!this.getAnoInicioSistema || !this.getAnoAtualServidor) {
        return [];
      }
      let retornoOptions = [];
      for (
        let i = this.getAnoAtualServidor;
        i >= this.getAnoInicioSistema;
        i--
      ) {
        retornoOptions.push({ text: i, value: i });
      }
      this.options.aaletivo = retornoOptions;
      this.loading = false;
    },
    async getTurma() {
      if (this.choices.aaletivo === "") {
        return;
      }
      try {
        this.loading = true;
        const { data } = await TurmasRepository.getSelectTurmasPerfil({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.choices.aaletivo,
        });

        const turmas = data.results. filter( e => ehTurmaAEEouACP(e.cdtpatend, e.cdinstruc, e.cdserie) )

          this.options.cdturma = turmas.map((key) => ({
          text: `${key.nmturma} - ${key.horario}`,
          value: key.cdturma,
          tipodeensino: key.cntpensin,
          cdinstruc: key.cdinstruc,
          cdserie: key.cdserie,
          cdtpatend: key.cdtpatend,
        }));



      } finally {
        this.loading = false;
      }
      this.step = 2;
      //console.log(this.choices);
    },
    async getEtapa() {
      if (this.choices.cdturma === "") {
        return;
      }
      try {
        this.loading = true;
        const {
          data,
        } = await DisciplinaRepository.getSelectDisciplinaPerfilPeriodo({
          ...this.userProfessor,
          ...this.school,
          aaletivo: this.choices.aaletivo,
          cdturma: this.choices.cdturma,
        });

        this.options.cddiscipl = data.results.disciplinas.map((key) => ({
          text: key.dsdiscipl,
          value: key.cddiscipl,
        }));
      } finally {
        this.loading = false;
      }
      this.step = 3;
    },
    key(k) {
      return JSON.stringify(k);
    },
    back(choice) {
      this.step -= 1;
      this.choices[choice] = null;
    },
    confirm() {
      this.$emit("chosen", this.choices);
      this.step = 4;
    },
  },
  computed: {
    ...mapGetters([
      "getAnoSistema",
      "getAnoAtualServidor",
      "getAnoInicioSistema",
      "userProfessor",
      "school",
    ]),
    anoletivo() {
      return this.options.aaletivo;
    },
    turmas() {
      return this.options.cdturma;
    },
    disciplinas() {
      return this.options.cddiscipl;
    },
    labelDisciplina() {
      return this.choices.aaletivo >= 2020 &&
        this.choices.tipoDeEnsino === "I" &&
        this.choices.cdturma
        ? "Campos de Experiência"
        : "Disciplina";
    },
    nomeTurma() {
      let dados = _.find(this.options.cdturma, ["value", this.choices.cdturma]);
      return dados.text;
    },
    nomeDisciplina() {
      let dados = _.find(this.options.cddiscipl, [
        "value",
        this.choices.cddiscipl,
      ]);
      return dados.text;
    },
  },
};
</script>
